import { createSkeletonFragment } from '../../../shader/fragments/skeleton-fragment.js';
import { MSH_HAS_SKELETON, MSH_HAS_SKELETON_8 } from '../../mesh-features.js';

const pbrExt = {
  id: "skeleton",
  phase: "vertex",
  frag(ctx) {
    if (!(ctx._meshFeatures & MSH_HAS_SKELETON)) {
      return null;
    }
    return createSkeletonFragment((ctx._meshFeatures & MSH_HAS_SKELETON_8) !== 0);
  },
  bind(ctx, entries, b) {
    const mesh = ctx._mesh;
    if (!(ctx._meshFeatures & MSH_HAS_SKELETON) || !mesh?.skeleton) {
      return b;
    }
    entries.push({ binding: b++, resource: mesh.skeleton.boneTexture.createView() });
    return b;
  }
};

export { createSkeletonFragment, pbrExt };
//# sourceMappingURL=skeleton-fragment.js.map
